import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { setUserProperties } from '~/utils/analytics'
import {
  collectUtmsToPropagate,
  getAllowedUtmQuery,
  hasMissingAllowedUtms,
  mergeRouteQueryWithUtms,
} from '~/utils/utm'

const router = createRouter({
  history: createWebHistory('/'),
  routes: setupLayouts(routes),
})

// Push UTMs from the entry URL immediately (before any GTM event fires)
setUserProperties(getAllowedUtmQuery(
  Object.fromEntries(new URLSearchParams(window.location.search)),
))

router.beforeEach((to, from, next) => {
  const mergedQuery = mergeRouteQueryWithUtms(
    to.query,
    collectUtmsToPropagate(from.query),
  )

  if (hasMissingAllowedUtms(to.query, mergedQuery)) {
    return next({
      path: to.path,
      hash: to.hash,
      query: mergedQuery,
      replace: true,
    })
  }

  next()
})

router.afterEach((to) => {
  setUserProperties(getAllowedUtmQuery(to.query))
})

export { router }
